import type { JSX } from "preact";

/**
 * A person's picture, or their initials on a colour derived from their name.
 * The colour comes from the server so the same person looks the same in the
 * console and in the customer's widget.
 */
export function Avatar({
  name,
  color,
  url,
  size = 32,
}: {
  name: string;
  color?: string;
  url?: string | null;
  size?: number;
}): JSX.Element {
  const style = { width: `${size}px`, height: `${size}px`, fontSize: `${Math.round(size * 0.4)}px` };
  if (url) return <img class="avatar" src={url} alt="" style={style} />;
  const initials =
    name
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part.charAt(0).toLocaleUpperCase("tr"))
      .join("") || "?";
  return (
    <span class="avatar" style={{ ...style, background: color ?? "var(--sea)" }} aria-hidden="true">
      {initials}
    </span>
  );
}
